import { render, staticRenderFns } from "./NavbarTodayIcon.vue?vue&type=template&id=76163c1b&"
import script from "./NavbarTodayIcon.vue?vue&type=script&lang=ts&"
export * from "./NavbarTodayIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('76163c1b', component.options)
    } else {
      api.reload('76163c1b', component.options)
    }
    module.hot.accept("./NavbarTodayIcon.vue?vue&type=template&id=76163c1b&", function () {
      api.rerender('76163c1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/NavbarTodayIcon.vue"
export default component.exports